module.exports = __webpack_public_path__ + "static/media/logo-avaliare.f90b202d.png";